<button
  type="button"
  mat-menu-item
  matTooltip="Clone Case"
  matTooltipPosition="above"
  [matTooltipShowDelay]="1000"
  (click)="cloneCase()"
>
  <mat-icon>content_copy</mat-icon>
  <span>Clone Case</span>
</button>
